
(function(){
  function dl(event, payload){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: event, ecommerce: payload || {}});
    if (window.fbq) {
      var map = { 'view_item':'ViewContent', 'add_to_cart':'AddToCart', 'begin_checkout':'InitiateCheckout' };
      var ev = map[event]; if (ev) fbq('track', ev, payload || {});
    }
    if (window.ttq) {
      var map2 = { 'view_item':'ViewContent', 'add_to_cart':'AddToCart', 'begin_checkout':'InitiateCheckout' };
      var ev2 = map2[event]; if (ev2) ttq.track(ev2, payload || {});
    }
    if (window.gtag) {
      gtag('event', event, payload || {});
    }
  }

  // View Item on product page
  if (window.GWANDLAUS_CONTEXT && GWANDLAUS_CONTEXT.template === 'product' && GWANDLAUS_CONTEXT.product){
    dl('view_item', {
      value: Number(GWANDLAUS_CONTEXT.product.price || 0),
      items: [{ item_id: String(GWANDLAUS_CONTEXT.product.id), item_name: GWANDLAUS_CONTEXT.product.title, currency: GWANDLAUS_CONTEXT.currency }]
    });
  }

  // Add to cart listener (form submit or button click)
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (f && /\/cart\/add/.test(f.action || '')){
      dl('add_to_cart', {});
    }
  }, true);
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t) return;
    var isCheckout = (t.matches('a[href*="/checkout"], button[name="checkout"], button[data-checkout]'));
    if (isCheckout){
      dl('begin_checkout', {});
    }
  }, true);
})();
